var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "pl-0 pr-0 pt-0 pb-0" },
    [
      _vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "programmeGroup",
                    breakpoint: "md",
                    label: "Programme",
                    "label-for": "programme",
                    horizontal: _vm.horizontal,
                    validated: ""
                  }
                },
                [
                  _vm.hideNewField
                    ? _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          options: _vm.programmes,
                          id: "programmeselect",
                          required: ""
                        },
                        on: {
                          input: function($event) {
                            _vm.selectionMade($event)
                          },
                          change: function($event) {
                            _vm.selectionMade($event)
                          }
                        },
                        model: {
                          value: _vm.selected_programme,
                          callback: function($$v) {
                            _vm.selected_programme = $$v
                          },
                          expression: "selected_programme"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideNewField
                    ? _c("b-form-input", {
                        attrs: {
                          type: "text",
                          placeholder: "New Programme name....",
                          required: ""
                        },
                        model: {
                          value: _vm.newProgrammeName,
                          callback: function($$v) {
                            _vm.newProgrammeName = $$v
                          },
                          expression: "newProgrammeName"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.hideNewField &&
                !_vm.loading &&
                !_vm.noNew &&
                !_vm.selected_programme,
              expression:
                "hideNewField && !loading && !noNew && !selected_programme"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function($event) {
                      _vm.addNew()
                    }
                  }
                },
                [_vm._v("Add New")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hideNewField && !_vm.loading && !_vm.noNew,
              expression: "!hideNewField && !loading && !noNew"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "success" },
                  on: {
                    click: function($event) {
                      _vm.save()
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "default" },
                  on: {
                    click: function($event) {
                      _vm.cancelAdd()
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e836000", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e836000","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgrammeSelection.vue
// module id = null
// module chunks = 